import React from "react";
import Badge from "../Badge";
import { convertToTitleCase } from "../../Utils";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import ConsultantCard from "../ConsultantCard";

dayjs.extend(customParseFormat);

const TutoringCard = ({ item }) => {
  const { t, i18n } = useTranslation();

  const currentDate = new Date();

  let availableSchedules = item.schedules.items
    ? item.schedules.items
        .filter(
          (schedule) =>
            new Date(schedule.scheduledAt) > currentDate &&
            schedule.status === "AVAILABLE"
        )
        .sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt))
    : [];

  if (item.available === false) {
    availableSchedules = [];
  }

  return (
    <div className="flex justify-between flex-col flex-auto gap-4 overflow-hidden">
      <div className="flex flex-col gap-3">
        {item.imageUrl ? (
          <div className="relative rounded-md w-full h-auto aspect-video overflow-hidden">
            <img
              className="absolute object-contain w-full h-full z-10"
              src={item.imageUrl}
              alt="Banner"
              loading="lazy"
            />
            <div
              className="absolute w-full h-full bg-fill blur-[50px] brightness-90 mask-gradient"
              style={{
                backgroundImage: `url('${item.imageUrl}')`,
              }}
            ></div>
          </div>
        ) : (
          <div className="rounded-md w-full h-auto aspect-video text-center overflow-hidden bg-gray-200 text-sm text-gray-500 flex flex-col justify-center">
            {t("No Image")}
          </div>
        )}
        <div className="flex flex-wrap gap-2">
          <Badge title={convertToTitleCase(item.type)} type="success" />
          <Badge title={item.category.name} type="alert" />
          {item.zoomEnabled && <Badge title={t("Zoom")} />}
          {item.callEnabled && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-violet-100 text-violet-600">
              {t("Video Call")}
            </span>
          )}
          {item.callEnabled && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-violet-100 text-violet-600">
              {t("Screen Sharing")}
            </span>
          )}
        </div>

        <div>
          <h3 className="text-sm font-bold text-gray-900 text-left line-clamp-2">
            {item.title}
          </h3>
        </div>
        <div>
          {availableSchedules.length > 0 ? (
            <h3 className="text-sm font-normal text-gray-500 text-left line-clamp-3">
              {"Mulai"}{" "}
              {dayjs(availableSchedules[0].scheduledAt)
                .locale(i18n.language)
                .format("DD MMM YYYY HH:mm")}
            </h3>
          ) : (
            <h3 className="text-sm font-normal text-gray-500 text-left line-clamp-3">
              {t("Schedule Not Available")}
            </h3>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ConsultantCard consultant={item.consultant} />
        </div>
        <div className="flex justify-between items-center overflow-hidden">
          <NumericFormat
            className="text-sm font-bold text-gray-900 text-left"
            displayType={"text"}
            value={item?.price}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"Rp "}
          />
          <p className="text-sm font-normal text-gray-500 text-left">
            {item?.duration} {t("Minute")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TutoringCard;
